<!-- eslint-disable @angular-eslint/template/cyclomatic-complexity -->
<div class="product-item" #productItem>
    <a
        [attr.aria-labelledby]="'product-item-meta-' + id"
        [attr.href]="urlRedirect"
        [attr.title]="title"
        [id]="gridProductId"
        data-cs-override-id
        #productItemMeta>
        <!-- In the case where alternative views are activated, they are displayed in addition to the h-grid result item-->
        <!-- We make the superposition between the alternative views and the grid item, the alternative views will be visible only on hover on Desktop and will be visible on Mobile if the products are displayed on "list" mode -->

        <div class="default-image" #imageResizerDivContainer>
            @if (shouldShowAlternativeViews && isBrowserMode) {
            <h-grid-result-alternative-views
                [product]="product"
                [isMobile]="isMobile"
                [isFetchpriorityImage]="index === 0"
                [shouldDisplayVtoTag]="isVtoDisplayed && isMobile"
                [shouldDisplayEngravingTag]="product.isEngravable && isMobile"
                [shouldDisplayTagDisplayOnly]="
                    (shouldDisplayTagDisplayOnly$ | async) === true ? controlPosition : lowPosition
                "
                [shouldDisplayVideo]="hasVideo"
                [isFocused]="showAlternativesViewsOnDesktop">
            </h-grid-result-alternative-views>
            }

            <ng-container #imageResizerContainer [ngTemplateOutlet]="imageResizer"> </ng-container>
            <!-- Show the grid item tag (vto or engraving) only on the first image (no alternative view) -->
            @if ({ appearance: !isMobile || isListMode || product.isHero ? borderRadius : svgOnly }; as tag) { @if
            (isVtoDisplayed && isBrowserMode) {
            <h-tag
                [class.hide-item-tag]="showAlternativesViewsOnMobile && isBrowserMode"
                [appearance]="tag.appearance"
                [tagSize]="isMobile ? 'xsmall' : 'small'"
                [backgroundOpacity]="0.6"
                [attr.data-testid]="'vto-grid-icon'"
                class="item-tag">
                <h-svg-icon svg [name]="'camera-flash'" class="vertical-align"></h-svg-icon>
                @if (tag.appearance !== 'svg-only') {
                <div class="align">
                    <span
                        data-nosnippet
                        class="tag-label label-small-bold-uppercase"
                        i18n="@@hermes.product-page.vto-trybutton"
                        >Try-it</span
                    >
                </div>
                }
            </h-tag>
            } @if (product.isEngravable && isBrowserMode) {
            <h-tag
                [class.hide-item-tag]="showAlternativesViewsOnMobile && isBrowserMode"
                [appearance]="tag.appearance"
                [tagSize]="isMobile ? 'xsmall' : 'small'"
                [backgroundOpacity]="0.6"
                [attr.data-testid]="'engraving-grid-icon'"
                class="item-tag">
                <h-svg-icon svg [name]="'edit-text'" class="vertical-align"></h-svg-icon>
                @if (tag.appearance !== 'svg-only') {
                <div class="align">
                    <span
                        data-nosnippet
                        class="tag-label label-small-bold-uppercase"
                        i18n="@@hermes.product-grid.engraving-icon"
                        >Engraving</span
                    >
                </div>
                }
            </h-tag>
            } } @if ((shouldDisplayTagDisplayOnly$ | async) === true) {
            <h-out-of-stock-label
                [product]="product"
                class="tag-unavailable"
                [ngClass]="{ 'high-position': controlPosition === highPosition }">
                <div i18n="@@hermes-grid-tag.unavailable">Available soon</div>
            </h-out-of-stock-label>
            }
        </div>

        <ng-template #imageResizer>
            <h-image-resizer
                [class.hide-image-resizer]="showAlternativesViewsOnMobile && isBrowserMode"
                [desktopUrl]="firstAsset"
                [isMobile]="isMobile"
                [mediaType]="product.isHero ? heroProduct : productInGrid"
                [imageId]="id"
                [imageFetchPriority]="index === 0"
                (imageInViewPort)="onImageInViewPort($event)">
            </h-image-resizer>
        </ng-template>

        <div
            class="product-item-meta"
            #informationOfProduct
            data-cs-override-id
            [id]="'product-item-meta-' + id"
            [attr.role]="'text'">
            <span
                [id]="'product-item-meta-name-' + id"
                class="product-item-name"
                [ngClass]="isMobile ? 'paragraph-small' : 'paragraph-medium'"
                [class.product-item-name-quick-buy]="product.quickBuyProperties?.eligible"
                >{{ product.title }}</span
            >
            @if (product.color && !product.isColorless) {
            <span class="product-item-colors" hSrOnlyNoSnippet>
                <ng-container i18n="@@hermes.accessibility.comma-separator">,&nbsp;</ng-container>
                <span i18n="@@hermes-global-translations.color">Color</span>
                <ng-container i18n="@@hermes.accessibility.colon">:&nbsp;</ng-container>
                {{ product.color }}
            </span>
            } @if (product.displayNameList) {
            <span
                class="product-item-name product-item-name-list"
                [ngClass]="isMobile ? 'label-small-bold-uppercase' : 'label-medium-bold-uppercase'">
                {{ product.displayNameList | uppercase }}
            </span>
            } @if (product.price) {
            <div class="product-item-price paragraph-small">
                <span hSrOnlyNoSnippet>
                    <ng-container i18n="@@hermes.accessibility.comma-separator">,&nbsp;</ng-container>
                </span>
                <h-price
                    [price]="product.price"
                    [size]="'small'"
                    [format]="'short'"
                    [isIndicative]="product.priceType === 'indicative'">
                </h-price>
            </div>
            } @if (product.massVolume && product.priceType === 'fixed') {
            <div class="product-item-variants paragraph-small">
                <span hSrOnlyNoSnippet>
                    <ng-container i18n="@@hermes.accessibility.comma-separator">,&nbsp;</ng-container>
                    <span i18n="@@hermes-global-translations.volume">Volume</span>
                    <ng-container i18n="@@hermes.accessibility.colon">:&nbsp;</ng-container>
                </span>
                {{ product.massVolume }}
            </div>
            } @if (product.gridAssetsVariants.length > 1) {
            <div class="product-variants-color paragraph-small">
                <h-image-variants-gallery
                    style="margin: auto 0"
                    [assets]="assetVariantsGallery"
                    [assetsParameters]="gridAssetsVariantsParameters"
                    [numberOfImageDisplayed]="numberOfImageDisplayed">
                    <ng-template [hImageVariantsGalleryPart]="'accessibility'">
                        <span hSrOnlyNoSnippet>
                            @if (product.gridAssetsVariants.length === 2) {

                            <span i18n="@@hermes.grid-page.grouping-other-color-option">Other color option</span>

                            } @if (product.gridAssetsVariants.length > 2) {

                            <span i18n="@@hermes.grid-page.grouping-other-colors-options">Other colors options</span>

                            } @for ( asset of product.gridAssetsVariants.slice(0, numberOfImageDisplayed); track asset;
                            let i = $index) { @if (i !== 0) {

                            <span i18n="@@hermes.accessibility.comma-separator">,&nbsp;</span>
                            <span>{{ asset.title }}</span>

                            } }
                            <span i18n="@@hermes.accessibility.comma-separator">,&nbsp;</span>
                        </span>
                    </ng-template>
                </h-image-variants-gallery>
            </div>
            } @if (hasMoreColors) {
            <div class="product-item-more-colors paragraph-small">
                <span hSrOnlyNoSnippet>
                    <ng-container i18n="@@hermes.accessibility.comma-separator">,&nbsp;</ng-container>
                </span>
                <span i18n="@@hermes.grid-page.beltkit-more-colors">More colors</span>
            </div>
            } @if (isVtoDisplayed) {
            <div class="product-item-vto">
                <span hSrOnlyNoSnippet>
                    <ng-container i18n="@@hermes.accessibility.comma-separator">,&nbsp;</ng-container>
                    <ng-container i18n="@@hermes.product-grid.vto-icon-rendering"
                        >Can be virtually tried on
                    </ng-container>
                </span>
            </div>
            } @if (product.isEngravable) {
            <div>
                <span hSrOnlyNoSnippet>
                    <ng-container i18n="@@hermes.accessibility.comma-separator">,&nbsp;</ng-container>
                    <ng-container i18n="@@hermes.product-grid.engraving-service-rendering"
                        >Engraving service available
                    </ng-container>
                </span>
            </div>
            } @if (isRetailOnlyStock && (!product.size || product.size === 'SANS_TAILLE')) {
            <div class="product-item-retail-only-sticker-wrapper">
                <div
                    class="product-item-retail-only-sticker label-small-bold-uppercase"
                    i18n="@@hermes_grid.available-in-store-only">
                    Available in store only
                </div>
            </div>
            } @if ((shouldDisplayTagDisplayOnly$ | async) === true) {
            <div>
                @if (product.labelDisplayOnly === 'exceptional-product') {
                <span hSrOnlyNoSnippet i18n="@@hermes-grid-tag.exceptional-pieces">Unavailable</span>
                } @else {

                <span hSrOnlyNoSnippet i18n="@@hermes-grid-tag.unavailable">Available soon</span>

                }
            </div>
            } @if (product.personalize) {
            <h-personalize-label [persoProductType]="product.persoProductType"> </h-personalize-label>
            }

            <div class="product-item-add-to-cart">
                @if (quickBuyProductInfos) {
                <h-quick-buy-button
                    [id]="id"
                    [parentElementRefOfQuickBuyButton]="elementRefForQuickBuy"
                    [quickBuyProductInfos]="quickBuyProductInfos"
                    [describedBy]="'product-item-meta-name-' + id"></h-quick-buy-button>
                }
            </div>
        </div>
    </a>
</div>
